/*
  toNearestTen(5) => 10
  toNearestTen(15) => 20
  toNearestTen(12345) => 12350
*/
const toNearestTen = (value: number): number => Math.round(value / 10) * 10;

export default toNearestTen;
